import {AsyncAction} from 'overmind'
import {AIDAResponse, AIDASource} from './state'

interface AIDAResponseRaw {
  Response: string
  Sources: AIDASource[]
}

export const getAIDAResponse: AsyncAction<{prompt: string; chatId: string}, AIDAResponse> = async (
  {effects},
  {prompt, chatId}: {prompt: string; chatId: string}
) => {
  try {
    const data = (await effects.v1.aida.getAIDAResponse({prompt, chatId})) as AIDAResponseRaw
    if (data && data.Response && data.Sources) {
      return {
        response: data.Response,
        sources: data.Sources
      }
    }
    return {response: "Sorry, I couldn't process your request.", sources: []}
  } catch (error) {
    return {response: "Sorry, I couldn't process your request.", sources: []}
  }
}

export const clearAIDAConversation: AsyncAction<string, void> = async ({effects}, chatId: string) => {
  try {
    await effects.v1.aida.clearAIDAConversation(chatId)
  } catch (error) {
    return
  }
}
